import { Outlet, useLocation } from 'react-router-dom'
import MainLayout from '@/views/MainLayout'
import { SiteProviders } from '@/providers/site-providers'
import { PageSeo } from '@/seo/PageSeo'
import LocalBusinessJsonLd from '@/seo/LocalBusinessJsonLd'

export default function SiteLayout() {
  const { pathname } = useLocation()

  return (
    <SiteProviders>
      <PageSeo path={pathname} />
      {pathname === '/' && <LocalBusinessJsonLd />}
      <div className="site-shell">
        <MainLayout>
          <Outlet />
        </MainLayout>
      </div>
    </SiteProviders>
  )
}
